// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"98fba1ed","453":"75f4ec07"}[chunkId] + ".chunk.js";
};